/**
 * celestialArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const celestialArtPack: ToilePack = {
    slug: 'celestial-art',
    category: 'celestial',
    name: 'Celestial art',
    tagline: tagline('prints', 'charts', 'styles'),
    chips: chips('charts', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'phases', label: 'Moon phases', subject: 'eight cratered moons in an even arc from new to full and back'},
        {key: 'zodiac', label: 'Zodiac wheel', subject: 'a circle of twelve constellation figures, a sun and moon at the center'},
        {key: 'chart', label: 'Constellation chart', subject: 'stars joined by fine lines under translucent mythological figures'},
    ],
    styles: [
        {key: 'gold', label: 'Gold on navy', style: 'fine metallic gold linework and stippling', palette: 'gold on deep midnight blue', framing: 'tall plate, symmetrical, even margin'},
        {key: 'engraving', label: 'Engraving', style: 'dense copperplate hatching, an ornate ruled border', palette: 'black ink on aged cream paper', framing: 'tall plate, symmetrical, even margin'},
        {key: 'watercolor', label: 'Watercolor', style: 'soft washes bleeding into the paper, loose edges', palette: 'indigo and violet, gold-flecked splatter', framing: 'tall plate, symmetrical, even margin'},
    ],
    directions: ['a solar system chart instead', 'in silver on black', 'plainer, fewer ornaments'],
}
